import TriageRequestPopup from './TriageRequestPopup';

export default TriageRequestPopup;
